import { render, staticRenderFns } from "./GalleryThumb.vue?vue&type=template&id=933807ae&scoped=true&"
import script from "./GalleryThumb.vue?vue&type=script&lang=js&"
export * from "./GalleryThumb.vue?vue&type=script&lang=js&"
import style0 from "./GalleryThumb.vue?vue&type=style&index=0&id=933807ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933807ae",
  null
  
)

export default component.exports